const draftStatuses = {
  NEW: "new",
  DONE: "done",
  REJECTED: "rejected",
  REJECTED_EXTERNAL: "external_rejected",
  ACCEPTED: "accepted",
  ACCEPTED_EXTERNAL: "external_accepted",
  SAVED: "saved", // only used on "basic" workflow. In advanced workflow all drafts start with "new" status
};

export default draftStatuses;
